'use client'
import { useRouter } from 'next/navigation';
import React from 'react'
import { useToastStore } from '../store/localapi';
import { useGoogleLogin } from '@react-oauth/google';
import style from './login.module.css'
import buildUserObj from '../utils/buildUserObj';

// eslint-disable-next-line
export default function GoogleLogin({ handleLoginApi, terms, minage, seterr }: { handleLoginApi: (userObj: any, router: any, setErrors: (err: any) => void, setLoading?: (loading: boolean) => void) => void, terms: boolean, minage: boolean, seterr: (err: any) => void }) {
  const router = useRouter();
  const { showToast } = useToastStore();
  const gLogin = useGoogleLogin({
    onSuccess: async (tokenResponse) => {
      const { access_token } = tokenResponse;
      try {
        const res = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
          headers: { Authorization: `Bearer ${access_token}` },
        });
        const user = await res.json();
        const userObj = buildUserObj({
          name: user.name,
          email: user.email,
          picture: user.picture,
          login_type: "Gmail"
        });
        // console.log(userObj)
        handleLoginApi(userObj, router, seterr);
      } catch (error) {
        console.log(error)
        showToast("Failed to fetch Google user info", "error");
      }
    },
    onError: () => showToast("Google Login Failed", "error"),
    flow: "implicit", // or "auth-code" if you use backend
  });

  const googlelogin = () => {
    const newErrors = {
      minage: !minage ? 'confirm minimum age' : '',
      terms: !terms ? 'agree to terms' : ''
    };
    seterr(newErrors);
    if (Object.values(newErrors).some(Boolean)) return;
    gLogin();
  };

  return (
    <div
      className={style.LoginsocialIcon}
      onClick={(e) => { e.preventDefault(); googlelogin(); }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31" fill="none">
        <g clipPath="url(#clip0_2476_810)">
          <path d="M8.93455 13.2339L4.92822 10.2113C7.64884 4.90953 13.9943 2.33812 19.766 4.37443C21.0274 4.81941 22.723 5.74821 23.6575 6.69481C23.6897 6.72743 23.7316 6.75253 23.7013 6.80231L20.303 10.1234C20.2445 10.1384 20.0769 9.95558 20.0221 9.91181C16.1391 6.80102 10.4852 8.70474 8.93433 13.2339H8.93455Z" fill="#EA4536" />
          <path d="M19.7493 21.4661L23.6242 24.4246C22.3648 25.5565 20.9632 26.3296 19.3113 26.7934C13.5923 28.3994 7.57807 25.9728 4.92822 20.7589L8.93455 17.7363C9.71829 20.0623 11.7713 21.9323 14.2323 22.4421C16.0596 22.8206 18.1902 22.4865 19.7493 21.4665V21.4661Z" fill="#36A852" />
          <path d="M19.7491 21.4665C19.7568 21.4613 19.7701 21.4302 19.7936 21.4145C21.0284 20.5855 21.8834 19.3623 22.1573 17.9079H15.6772V13.3418H27.0174C27.7344 17.2784 26.733 21.6188 23.6903 24.3942C23.6656 24.4168 23.6296 24.4198 23.6242 24.4249L19.7493 21.4665H19.7491Z" fill="#557EBF" />
          <path d="M8.93454 13.2335C8.42753 14.714 8.43586 16.2549 8.93454 17.7355L4.92821 20.7581C3.21021 17.3778 3.19444 13.5897 4.92821 10.2109L8.93454 13.2335Z" fill="#F9BC17" />
        </g>
        <defs>
          <clipPath id="clip0_2476_810">
            <rect width="23.6052" height="23.6052" fill="white" transform="translate(3.63379 3.67773)" />
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}

// const device = deviceInfo();
// const deviceId = tohash(`${device.name}${device.platform}${device.os}${user.email}`);
// const userObj = {
//   user_email: user.email,
//   user_password: "",
//   a_id: 0,
//   login_type: "Gmail",
//   device_id: deviceId,
//   apple_socail_id: "",
//   device_name: device.name,
//   fcm_id: "",
//   user_name: user?.name,
//   user_image: user.picture || "",
//   user_dob: "",
//   app_ver: device.version,
//   user_cc: "US",
//   dev_cc: "US",
//   dev_make: device.os,
//   dev_model: device.platform,
//   app_usage_counter: "5000",
//   dev_lang: "eng"
// };